import { loadStripe } from '@stripe/stripe-js';

// Get publishable key from environment variables
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_YOUR_PUBLISHABLE_KEY_HERE';

// Initialize Stripe
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

console.log('Stripe configuration loaded with live restricted key');

// API endpoints
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const STRIPE_API = {
  createPaymentIntent: `${API_BASE_URL}/payments/create-payment-intent`,
  confirmPayment: `${API_BASE_URL}/payments/confirm-payment`,
  getStudentPayments: (studentId: string) => `${API_BASE_URL}/payments/student/${studentId}/history`,
  getTeacherEarnings: (teacherId: string) => `${API_BASE_URL}/payments/teacher/${teacherId}/earnings`,
  processRefund: `${API_BASE_URL}/payments/refund`,
  webhook: `${API_BASE_URL}/payments/webhook`
};

// Stripe configuration constants
export const STRIPE_CONFIG = {
  currency: 'usd',
  country: 'US',
  appearance: {
    theme: 'stripe' as const,
    variables: {
      colorPrimary: '#2563eb', // Blue-600 to match our theme
      colorBackground: '#ffffff',
      colorText: '#374151',
      colorDanger: '#dc2626',
      fontFamily: 'system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '8px'
    }
  }
};

// Helper function to create payment intent
export const createPaymentIntent = async (paymentData: any) => {
  console.log('Creating payment intent via API:', paymentData);
  
  try {
    const response = await fetch(STRIPE_API.createPaymentIntent, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paymentData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create payment intent');
    }

    const data = await response.json();
    console.log('Payment intent created successfully:', data);
    return data;
    
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};

// Helper function to confirm payment
export const confirmPayment = async (paymentIntentId: string) => {
  console.log('Confirming payment via API:', paymentIntentId);
  
  try {
    const response = await fetch(STRIPE_API.confirmPayment, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ paymentIntentId })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to confirm payment');
    }

    const data = await response.json();
    console.log('Payment confirmed successfully:', data);
    return data;
    
  } catch (error) {
    console.error('Error confirming payment:', error);
    throw error;
  }
};

export default stripePromise; 